<template lang="pug">
div
  .promo--location.px-4.pb-4
    SearchBox(v-model="search" placeholder="Nama store" @input="onSearch")
    ListItem(v-for="store in filteredStoreList" :item="store" :key="store.id" paddingY="0") 
    PromoListItemLoader(v-if="renderLoader" :length="3")
</template>

<script>
import { mapGetters } from 'vuex';
import { debounce } from '../helpers/utils';
import { ListItem, SearchBox } from '@ovo/ravier-vue';
import PromoListItemLoader from '../components/PromoListItemLoader';

export default {
  components: { SearchBox, ListItem, PromoListItemLoader },
  data() {
    return {
      search: '',
      page: 0,
    };
  },
  computed: {
    ...mapGetters({
      promoStoresByMerchants: 'getPromoStoresByMerchants',
      promoStoresEnd: 'getPromoStoresEnd',
      renderLoader: 'getRenderLoader',
    }),
    filteredStoreList() {
      if (this.promoStoresByMerchants) {
        return this.promoStoresByMerchants
          .map(item => {
            return {
              title: item.name,
              description: item.address,
            };
          });
      }
      return [];
    },
  },
  mounted() {
    this.fetchPromoStores(true);
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    onSearch(params) {
      debounce(()=> {
        this.search = params;
        this.fetchPromoStores(true);
      }, 300)();
    },
    async fetchPromoStores(firstLoad = false) {
      if (this.renderLoader) return;
      if (firstLoad) {
        this.page = 1;
      } else {
        if (this.promoStoresEnd) return;
        this.page += 1;
      }
      const payload = {
          merchantId: this.$route.query.merchant_id,
          promoId: this.$route.query.promo_id,
          page: this.page,
          limit: 50,
        };
        if (this.search !== '') {
          payload.keyword = this.search;
        }
      await this.$store.dispatch('getPromoStoresByMerchant', {
        firstLoad,
        payload,
      });
    },
    handleScroll(event) {
      let bottomOfWindow =
        Math.ceil(window.scrollY) + (window.innerHeight * 5 / 4) >= document.documentElement.scrollHeight;
      if (bottomOfWindow) {
        this.fetchPromoStores();
      }
    },
  },
};
</script>
